import type { ProductProps } from 'Components/widgets/product/Product.utils';
import type { ThumbnailProduct } from 'Utils/resort-thumbnail-query/resortThumbnailQuery';
export const filterProductsByFlightDuration = ({
  facet,
  productList,
}: {
  facet: string;
  productList: ReadonlyArray<ProductProps | ThumbnailProduct>;
}): Array<ProductProps | ThumbnailProduct> => {
  switch (facet) {
    case '2h':
      return productList.filter(
        (product) =>
          typeof product?.price?.termsAndConditions?.flightDuration === 'number' &&
          product?.price?.termsAndConditions?.flightDuration <= 120,
      );

    case '4h':
      return productList.filter(
        (product) =>
          typeof product?.price?.termsAndConditions?.flightDuration === 'number' &&
          product?.price?.termsAndConditions?.flightDuration > 120 &&
          product?.price?.termsAndConditions?.flightDuration <= 240,
      );

    case '8h':
      return productList.filter(
        (product) =>
          typeof product?.price?.termsAndConditions?.flightDuration === 'number' &&
          product?.price?.termsAndConditions?.flightDuration > 240 &&
          product?.price?.termsAndConditions?.flightDuration <= 480,
      );

    case '8hmore':
      return productList.filter(
        (product) =>
          typeof product?.price?.termsAndConditions?.flightDuration === 'number' &&
          product?.price?.termsAndConditions?.flightDuration > 480,
      );

    default:
      return [];
  }
};
